module.exports = __webpack_public_path__ + "img/移门.3c3fa9e2.webp";